/* import __COLOCATED_TEMPLATE__ from './start.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class StartTimingComponent extends Component
{
	@service ajax;
	@service socketGuru;

	@tracked selectedStartTime = null;
	@tracked selectedStartImpulse = null;

	constructor()
	{
		super(...arguments);

		// Bind WebSocket event handler
		this._boundHandleSocketEvent = this._handleSocketEvent.bind(this);
		this.socketGuru.events.addEventListener('newEvent', this._boundHandleSocketEvent);

		// Fetch initial auto-association state from backend
		this.fetchAutoAssociationStatus();
	}

	willDestroy()
	{
		this.socketGuru.events.removeEventListener('newEvent', this._boundHandleSocketEvent);
		super.willDestroy();
	}

	/**
	 * Fetch current auto-association status from backend
	 */
	async fetchAutoAssociationStatus()
	{
		if (!this.args.event) {
			return;
		}

		try {
			const eventId = this.args.event.id;
			const response = await this.ajax.request(`/events/${eventId}/autoAssociation/start/status`);

			// Update local state to match backend
			this.args.event.set('shouldAutoAssociateStart', response.isRunning);
		} catch (error) {
			console.error('Error fetching auto-association status:', error);
		}
	}

	/**
	 * Handle WebSocket events
	 */
	_handleSocketEvent(event)
	{
		const { eventName, data } = event.detail;

		console.log('Received WebSocket event:', eventName);

		if (eventName === 'autoAssociationStateChanged') {
			console.log('Auto-association state change event received:', data);
			this.handleAutoAssociationStateChange(data);
		}
	}

	/**
	 * Handle auto-association state change from WebSocket
	 */
	handleAutoAssociationStateChange(payload)
	{
		if (!this.args.event) {
			console.log('No event in args, ignoring state change');
			return;
		}

		const data = JSON.parse(payload);

		console.log(`Received state change: eventId=${data.eventId} (type: ${typeof data.eventId}), current event=${this.args.event.id} (type: ${typeof this.args.event.id}), type=${data.type}, typeId=${data.typeId}, isRunning=${data.isRunning}`);

		// Only update if this is for our event, 'start' type, and no typeId
		// Convert both to strings for comparison to handle type mismatches
		if (String(data.eventId) === String(this.args.event.id) &&
		    data.type === 'start' &&
		    data.typeId === null) {
			this.args.event.set('shouldAutoAssociateStart', data.isRunning);
			console.log(`✓ Auto-association state updated for event ${data.eventId}: ${data.isRunning}`);
		} else {
			console.log(`✗ State change ignored (event, type, or typeId mismatch)`);
		}
	}

	@action
	startTimeClicked(timingRecord)
	{
		this.selectedStartTime = timingRecord;
	}

	@action
	startImpulseClicked(timingRecord)
	{
		this.selectedStartImpulse = timingRecord;
	}

	@action
	async toggleAutoAssociate()
	{
		if (!this.args.event) {
			return;
		}

		const eventId = this.args.event.id;
		const currentStatus = this.args.event.shouldAutoAssociateStart;

		try {
			if (currentStatus) {
				// Stop auto-association
				await this.ajax.post(`/events/${eventId}/autoAssociation/start/stop`);
			} else {
				// Start auto-association
				await this.ajax.post(`/events/${eventId}/autoAssociation/start/start`);
			}

			// State will be updated via WebSocket event
		} catch (error) {
			console.error('Error toggling auto-association:', error);

			// Optionally: show error to user or revert optimistic update
		}
	}
}

